module.exports = __webpack_public_path__ + "static/media/Logo-01.4fdcd5ef.svg";